import { Formik, Form } from 'formik'
import { FC, useState, useEffect } from 'react'
import InstutitionProfileDetails from './profileDetails'
import Documents from '../../../../../../commons/userDetails/documents'
interface PersonalDetailsProps {
  disabled?: boolean
  institution: any
}
const InstitutionPersonalDetails: FC<PersonalDetailsProps> = ({
  disabled,
  institution,
}) => {
  const identifications = institution?.documents?.filter(
    (document: any) => document?.type == 'Identification',
  )
  const registrations = institution?.document?.filter(
    (document: any) => document?.type == 'Registration',
  )
  const licenses = institution?.documents?.filter(
    (document: any) => document?.type == 'License',
  )
  const signature = institution?.documents?.find(
    (document: any) => document?.type == 'Signature',
  )
  const citizenship = identifications?.findIndex(
    (document) => document?.infos?.name == 'Citizenship',
  )
  const passport = identifications?.findIndex(
    (document) => document?.infos?.name == 'Passport',
  )
  const nationalId = identifications?.findIndex(
    (document) => document?.infos?.name == 'National Id',
  )
  const initial = {
    name: '',
    email: '',
    phoneNo: '',
    countryCode: 977,
    address: '',
    departments: [],
    instituteType: '',
    yos: '',
    serviceArea: '',
    serviceIncludes: [],
    specializations: [],
    identifications: [
      {
        image: '',
        name: 'Citizenship',
        number: '',
      },
      {
        image: '',
        name: 'Passport',
        number: '',
      },
      {
        image: '',
        name: 'National Id',
        number: '',
      },
    ],
    licenses: [],
    registrations: [],
    signature: '',
  }
  const [initialValues, setInitialValues] = useState<any>(initial)

  useEffect(() => {
    if (!!institution?.id) {
      setInitialValues({
        name: institution?.name,
        email: institution?.email,
        phoneNo: institution?.phoneNo,
        countryCode: institution?.countryCode,
        address: institution?.infos?.address,
        departments: institution?.departments?.map(
          (department) => department?.id,
        ),
        instituteType: institution?.infos?.instituteType,
        yos: institution?.infos?.yos,
        specializations: institution?.specializations,
        serviceArea: '',
        serviceIncludes: institution?.infos?.serviceIncludes,
        signature: !!signature?.id ? signature?.infos?.image : null,
        licenses: licenses?.length
          ? licenses?.map((license: any) => {
              return {
                id: license?.id,
                name: license?.infos?.name,
                image: license?.infos?.image,
                oldPath: license?.infos?.image,
              }
            })
          : [],
        registrations: registrations?.length
          ? registrations?.map((license: any) => {
              return {
                id: license?.id,
                name: license?.infos?.name,
                image: license?.infos?.image,
                oldPath: license?.infos?.image,
              }
            })
          : [],
        identifications:
          identifications?.length >= 3
            ? identifications
            : [
                !!identifications?.[citizenship]
                  ? {
                      ...identifications[citizenship]?.infos,
                      oldPath: identifications[citizenship]?.infos?.image,
                      id: identifications[citizenship]?.id,
                    }
                  : {
                      image: '',
                      name: 'Citizenship',
                      number: '',
                    },
                !!identifications?.[passport]
                  ? {
                      ...identifications[passport]?.infos,
                      oldPath: identifications[passport]?.infos?.image,
                      id: identifications[passport]?.id,
                    }
                  : {
                      image: '',
                      name: 'Passport',
                      number: '',
                    },
                !!identifications?.[nationalId]
                  ? {
                      ...identifications[nationalId]?.infos,
                      oldPath: identifications[nationalId]?.infos?.image,
                      id: identifications[nationalId]?.id,
                    }
                  : {
                      image: '',
                      name: 'National Id',
                      number: '',
                    },
              ],
      })
    } else {
      setInitialValues(initial)
    }
  }, [institution?.id])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {}}
      enableReinitialize
    >
      {({ handleSubmit, setFieldValue, values, errors }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <InstutitionProfileDetails
              setFieldValue={setFieldValue}
              values={values}
              errors={errors}
              disabled={disabled}
            />
            <Documents
              identifications={values?.identifications}
              licenses={values?.licenses}
              registrations={values?.registrations}
              setFieldValue={setFieldValue}
              disabled={disabled}
              role="institution"
            />
          </Form>
        )
      }}
    </Formik>
  )
}

export default InstitutionPersonalDetails
